import { Paper, SkeletonContainer, SkeletonText } from '@sanlam-glacier/app-common/components';
import './proposal-skeleton-loader.styles.scss';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';

export const ProposalSkeleton = () => {
  return (
    <Paper className='proposal-skeleton-loader-container'>
      <SkeletonContainer>
        <Grid row>
          <Block sm={3}>
            <SkeletonText lineHeight={15} marginBottom={15} width={400} />
            <SkeletonText lineHeight={20} width={200} />
          </Block>
          <Block smStart={11} sm={2}>
            <SkeletonText lineHeight={40} />
          </Block>
        </Grid>
        <Grid row>
          <Block lgEnd={12} lg={3} sm={12} smStart={1} smEnd={12}>
            <SkeletonText lineHeight={40} />
          </Block>
        </Grid>
        <Grid row>
          <Block lg={12} sm={12}>
            <SkeletonText className='proposal-skeleton-loader-header-body' width={'100%'} />
          </Block>
        </Grid>
      </SkeletonContainer>
    </Paper>
  );
};
